import {DefaultTheme} from 'styled-components';
import {mix, rgba} from 'polished';

import {black, chambray, cod, ice, malibu, white} from '../colors';

export const Theme: DefaultTheme = {
    svg: {
        authors: {
            backgroundColor: ice,
            foregroundColor: rgba(chambray, 0.2)
        }
    },
    color: {
        primary: chambray,
        secondary: malibu,
        foreground: black,
        breadcrumb: mix(0.265, chambray, ice),
        background: white,
        label: mix(0.4, cod, white)
    },
    font: {
        family: {
            primary: '"Baton Turbo", sans-serif',
            secondary: '"Baton Turbo Book", sans-serif'
        },
        weight: {
            normal: 400,
            bold: 600,
            heavy: 900
        }
    },
    breakpoint: {
        tablet: '576px',
        desktop: '1144px'
    }
};
